import React, { useEffect, useState } from "react";

const LinkPreview = ({ url }) => {
  const [data, setData] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  // ⚡ On corrige ici l'url avant fetch
  const safeUrl = url.startsWith('http') ? url : `https://${url}`;

// 🧠 Détection des liens YouTube (classiques ou partagés)
  const isYouTube =
    /(?:youtube\.com|youtu\.be)/i.test(safeUrl);

  useEffect(() => {
    const fetchPreview = async () => {
      try {
        const res = await fetch(`${API_URL}/api/preview?url=${encodeURIComponent(safeUrl)}`);
        const json = await res.json();
        setData(json);
      } catch (err) {
        console.error("Erreur preview:", err);
      }
    };
    fetchPreview();
  }, [safeUrl]);


  if (!data) {
    return (
      <a href={safeUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
        {safeUrl}
      </a>
    );
  }

  if (data.error) {
    return (
      <a href={safeUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
        {safeUrl}
      </a>
    );
  }
// 🎯 Si lien YouTube → n'affiche que l’image (ou rien du tout)
  if (isYouTube) {
    return (
      <a href={safeUrl} target="_blank" rel="noopener noreferrer">
        {data.image && (
          <img
            src={data.image}
            alt="YouTube thumbnail"
            className="w-full rounded-xl mt-2 object-contain"
            style={{ maxHeight: "200px" }}
          />
        )}
      </a>
    );
  }
  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden mt-2 bg-gray-50 hover:shadow-md transition-shadow max-w-[100%]">
      <a href={safeUrl} target="_blank" rel="noopener noreferrer" className="no-underline text-black">
        <div className="flex gap-3 p-3">
          {data.image && (
            <img
              src={data.image}
              alt={data.title}
              className="w-24 h-24 object-contain rounded-lg flex-shrink-0 max-w-full"
style={{ maxHeight: "200px" }}
            />
          )}
          <div className="overflow-hidden">
            <h4 className="link-preview-title font-semibold text-sm truncate" >{data.title}</h4>
            <p className="link-preview-description text-xs text-gray-500 line-clamp-2 overflow-hidden text-ellipsis">{data.description}</p>
            <p className="link-preview-site text-xs text-blue-600 mt-1 truncate">{data.siteName}</p>
          </div>
        </div>

      </a>
    </div>
  );
};

export default LinkPreview;
